import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { makeStyles } from "@mui/styles";
import { statusTotal } from "../components";
import Header from "../components/orderInquiry/Header";
import Content from "../components/orderInquiry/Content";

import {
  makeStartDate,
  makeEndDate,
  changeDocumentTitle,
  startDateBefore,
  startDateAfter,
} from "../lib";
import OrderService from "../services/order";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
  headerContainer: {
    height: 57,
    paddingTop: 7,
    paddingRight: 27,
    paddingLeft: 18,
    backgroundColor: "#ffffff",
    borderRadius: 3.8,
    border: "solid 1px #ebedf8",
  },
  contentContainer: {
    marginTop: 25,
    padding: 0,
    backgroundColor: "#ffffff",
    borderRadius: 3.8,
    border: "solid 1px #ebedf8",
  },
}));

export default function OrderInquiry() {
  const classes = useStyles();

  const navigate = useNavigate();
  const methods = useForm();

  const [orders, setOrders] = useState<any[]>([]);
  const [summary, setSummary] = useState(null);

  const inquiry = useCallback(
    async (data: any) => {
      try {
        const orderService = new OrderService(navigate);
        const response = await orderService.inquiry(data);
        setOrders(response.data.orders);
        setSummary(response.data.summary);
      } catch (e) {
        console.error("failed to handle order:", e);
      }
    },
    [setOrders]
  );

  const onSubmit = async (data: any) => {
    await inquiry(data);
  };

  useEffect(() => {
    changeDocumentTitle("운송조회");
    queueMicrotask(async () => {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - startDateBefore);
      makeStartDate(startDate);

      const endDate = new Date();
      makeEndDate(endDate);
      endDate.setDate(new Date().getDate() + startDateAfter);

      await inquiry({ status: statusTotal, startDate, endDate });
    });
  }, []);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <Grid container direction={"column"}>
          <Grid item className={classes.headerContainer}>
            <Header summary={summary} />
          </Grid>
          <Grid item className={classes.contentContainer}>
            <Content orders={orders} />
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
}
